import React from 'react' // eslint-disable-line no-unused-vars
import css from './header.css'
/**
 * Header for grids
 */
export default ({ title }) => (
    <div className={css.header}>
        <span className={css.label}>{title}</span>
    </div>
)
